export const NAME = 'questions';
export const LEVEL_ONE = 'QuestionsComponentReducer';
